document.addEventListener("DOMContentLoaded", function () {

    const items = document.querySelectorAll(".mega-category");

    items.forEach(item => {

        item.addEventListener("mouseenter", function(){

            items.forEach(i=>i.classList.remove("active"));

            this.classList.add("active");

            let id=this.dataset.target;

            document.querySelectorAll(".mega-products").forEach(box=>{
                box.classList.add("hidden");
            });

            const target=document.getElementById(id);

            if(target){
                target.classList.remove("hidden");
            }

        });

    });

});

document.addEventListener("DOMContentLoaded", function () {

    const header = document.querySelector(".header-wrapper");

    document.querySelectorAll("[data-mega-menu]").forEach(function(menu){

        let timer;

        menu.addEventListener("mouseenter", function(){

            clearTimeout(timer);

            menu.setAttribute("open","");

            if(header){
                header.classList.add("menu-open");
            }

        });

        menu.addEventListener("mouseleave", function(){

            timer = setTimeout(function(){

                menu.removeAttribute("open");

                if(header && window.scrollY < 50){
                    header.classList.remove("menu-open");
                }

            },150);

        });

    });

});